/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux'
import classnames from 'classnames';
import { START } from 'pu-data/QuoteSteps';

import PartNumber from 'pu-react/components/PartNumber';
import Revision from 'pu-react/components/Revision';
import GerberFile from 'pu-react/components/GerberFile';
import InstantQuote from 'pu-react/components/InstantQuoteFC';
import BomLineItems from 'pu-react/components/BomLineItems';
import SmtPlacements from 'pu-react/components/SmtPlacements';
import ThruHolePlacements from 'pu-react/components/ThruHolePlacements';
import QfnPlacements from 'pu-react/components/QfnPlacements';
import DoubleSideTHT from 'pu-react/components/DoubleSideTHT';
import DoubleSideSMT from 'pu-react/components/DoubleSideSMT';
import LeadFreeProcessing from 'pu-react/components/LeadFreeProcessing';
import Class3Inspection from 'pu-react/components/Class3Inspection';
import RequiredInformation from 'pu-react/components/RequiredInformation';
import CustomQuote from 'pu-react/components/CustomQuote';
import Quantities from 'mx_pcb_assembly/components/form/Quantities';
import BgaPlacements from 'mx_pcb_assembly/components/form/BgaPlacements';
import Hidden from 'mx_pcb_assembly/components/form/Hidden';

import {
  changeParameter,
  doQuote,
  validator,
  showValidatorErrorMessages,
  hideValidatorErrorMessages
} from 'mx_pcb_assembly/store/slice';

const validatedFields = ['Quantity', 'Bom Line Items', 'QFN Placements', 'SMT Placements', 'Through Hole Placements']

const Parameters = () => {
  const dispatch = useDispatch();
  const {
    parameters,
    quoteStep,
    showMessages
  } = useSelector((state) => state.mx_assembly)

  const onChangeParameter = (name, value) => {
    dispatch(hideValidatorErrorMessages())
    dispatch(changeParameter({ name, value }))
  }

  const props = {
    parameters,
    onChangeParameter,
  }

  const onQuoteRequest = () => {
    dispatch(hideValidatorErrorMessages());
    const allValid = validatedFields.every((name) => validator.fieldValid(name))

    if (allValid) {
      dispatch(doQuote());
    } else {
      dispatch(showValidatorErrorMessages(validatedFields));
    }
  }

  return (
    <div className="pcb-form-section">
      <div className="row">
        <div className="col-md-6">
          <GerberFile
            {...props}
            errorMessage={validator.message('Zip file', parameters.filename, 'required')}
          />
        </div>
        <div className="col-md-6 instant-quote-top">
          <InstantQuote {...props} onQuoteRequest={onQuoteRequest} />
        </div>
      </div>
      <div className={classnames('row', quoteStep == START && 'd-none')}>
        <div className="col-md-6">
          <PartNumber
            {...props}
            errorMessage={validator.message('Part Number', parameters.part_number, 'required|min:3')}
          />
        </div>
        <div className="col-md-6">
          <Revision
            {...props}
            errorMessage={validator.message('Revision', parameters.revision, 'required')}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <Quantities
            {...props}
            required
            errorMessage={validator.message('Quantity', parameters.quantities, 'group_required|group_numeric|group_min:1,num')}
          />
        </div>
        <div className="col-md-6">
          <BomLineItems
            {...props}
            errorMessage={validator.message('Bom Line Items', parameters.bom_line_items, 'required|numeric|min:1,num')}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <SmtPlacements
            {...props}
            errorMessage={validator.message('SMT Placements', parameters.smt, 'required|numeric|min:0,num')}
          />
        </div>
        <div className="col-md-6">
          <ThruHolePlacements
            {...props}
            errorMessage={validator.message('Through Hole Placements', parameters.thru_hole, 'required|numeric|min:0,num')}
          />
        </div>
        <div className="col-md-6">
          <BgaPlacements {...props} />
        </div>
        <div className="col-md-6">
          <QfnPlacements
            {...props}
            errorMessage={validator.message('QFN Placements', parameters.qfn, 'required|numeric|min:0,num')}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <LeadFreeProcessing {...props} />
        </div>
        <div className="col-md-12">
          <DoubleSideTHT {...props} />
        </div>
        <div className="col-md-12">
          <DoubleSideSMT {...props} />
        </div>
        <div className="col-md-12">
          <Class3Inspection {...props} />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <RequiredInformation />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <InstantQuote {...props} onQuoteRequest={onQuoteRequest} />
        </div>
      </div>
      <Hidden />
      <CustomQuote label="">
        <div className="col-md-12">
          If you are not able to get an online quote you can request a &nbsp;
          <a className="link" href={Spree.routes.custom_quote_request_new_url}>custom quote</a>.
          You can also email us your BOM and Gerber files to &nbsp;
          <a href="mailto:support@pcbunlimited.com">support@pcbunlimited.com</a>.
        </div>
      </CustomQuote>
    </div>
  );
}

export default Parameters;
